import React from 'react';
import type { FunctionComponent, ReactNode } from 'react';

type Variant = 'admin' | 'staff';

type Props = {
  variant: Variant;
  className?: string;
  dataCy?: string;
  children: ReactNode;
};

const VARIANT_CLASS: Record<Variant, string> = {
  admin: 'bg-white px-5 py-6 md:px-8 md:py-7 rounded-xl shadow',
  staff: 'bg-white rounded-lg border border-gray-300 px-5 py-6 md:px-10 md:py-10',
};

const WelcomeCard: FunctionComponent<Props> = ({ variant, className, dataCy, children }) => (
  <div
    className={`${VARIANT_CLASS[variant]}${className ? ` ${className}` : ''}`}
    data-cy={dataCy}
  >
    {children}
  </div>
);

export default WelcomeCard;
